app.service('giftCardPaymentType', function (loading, modal, broker, orderUtils) {
	var $container, $self, $form, $giftCardForm, $giftCardNumber, $giftCardPin, $giftCardCounter;
	var callbackRefreshCart;

	function addGiftCard() {
		ignoreInputs(false);
		$('.gift-card-info', $self).remove();

		if (($giftCardPin.val().length && $giftCardNumber.val().length)) {
			var data = {
				giftCardPin: $giftCardPin.val(),
				giftCardNumber: $giftCardNumber.val()
			};
			loading.start();
			$.ajax({
				url: '/order-path-payment-gift-card-addition.ltr',
				type: 'post',
				data: data,
				success: function (html) {
					if ($('<div>' + html + '</div>').find('.gift-card-validation-error').length) {
						loading.stop();
						setElements(html);
						setEvents();
					} else {
						loading.reload({ soft: true });
					}
				},
				error: function () {
					modal.alert('Błąd przetwarzania karty podarunkowej');
				}
			});
		}
	}
	function removeGiftCard(giftCardNumber) {
		var data = {
			giftCardNumber: giftCardNumber
		};
		loading.start();
		$.ajax({
			url: '/order-path-payment-gift-card-removal.ltr',
			type: 'post',
			data: data,
			success: function () {
				loading.reload({ soft: true });		// po zmianach karty może dziać się bardzo dużo np zmiana form płatności dlatego zmieniam na przeładowanie za każdym razem
			},
			error: function () {
				modal.alert('Błąd usuwania karty podarunkowej');
			}
		});
	}

	function ignoreInputs(ignore) {
		$giftCardPin.ignore(ignore);
		$giftCardNumber.ignore(ignore);
	}

	function addAnotherGiftCard() {
		$self.addClass('show-gift-card-form');
		broker.trigger('BLOCK_PAYMENT_TYPE');
	}
	function removeAnotherGiftCard() {
		$self.removeClass('show-gift-card-form');
		$giftCardForm.find('input').val('');
		$('.gift-card-info', $self).remove();
		broker.trigger('UNBLOCK_PAYMENT_TYPE');
	}

	function giftCardNumberValid() {
		if ($giftCardForm.length) {
			if ($giftCardCounter.val() !== '0' && $giftCardPin.val() === '' && $giftCardNumber.val() === '') {
				ignoreInputs(true);
				$self.removeClass('gift-card-not-submitted');
			} else {
				ignoreInputs(false);
			}
		}

		if ($form.valid()) {
			if ($giftCardForm.length && $giftCardPin.val() !== '' && $giftCardNumber.val() !== '') {
				$self.addClass('gift-card-not-submitted');
				return false;
			}
		} else {
			return false;
		}

		return true;
	}

	function show() {
		$self.find('input').removeClass('ignore');
		$container.removeClass('gift-card-payment-hidden');
	}

	function hide() {
		if ($self) $self.find('input').addClass('ignore');
		if ($container) $container.addClass('gift-card-payment-hidden');
	}

	function removeValidationError() {
		$self.removeClass('gift-card-validation-error');
		$error.remove();
	}

	function checkFieldsFilled() {
		markFieldFilled.call($giftCardNumber);
		markFieldFilled.call($giftCardPin);
	}

	function markFieldFilled() {
		var $element = $(this);
		if ($element.length) {
			// setTimeout z opóźnieniem 0, aby w przypadku odpalenia eventu 'paste' pole value było wypełnione wklejanym tekstem
			setTimeout(function () {
				if ($element.val().length === $element.prop('maxlength')) {
					$form.addClass($element.prop('id') + '-filled');
				} else {
					$form.removeClass($element.prop('id') + '-filled');
				}
			}, 0);
		}
	}

	function setElements(html) {
		if (html) {
			$container.html(html);
		}
		$self = $("#gift-card-payment-box");
		$giftCardForm = $('#add-gift-card-form', $self);
		$giftCardNumber = $('#gift-card-number', $self);
		$giftCardPin = $('#gift-card-pin', $self);
		$giftCardCounter = $('#gift-card-counter', $self);
		$error = $('#gift-card-pin-error', $self);
	}

	function setEvents() {
		$(".js-add-gift-card", $self).on('click', function () {
			addGiftCard();
		});
		$(".js-remove-gift-card", $self).on('click', function () {
			if ($giftCardCounter.val() / 1 == 1) {
				orderUtils.ignore();
				orderUtils.send('RESET_GIFT_CARD_PAYMENT');
			} else {
				removeGiftCard($(this).data('gift-card'));
			}
		});
		$(".js-add-another-gift-card", $self).on('click', function () {
			addAnotherGiftCard();
		});
		$(".js-remove-another-gift-card", $self).on('click', function () {
			removeAnotherGiftCard();
		});

		$giftCardNumber.one('keyup', function () {
			removeValidationError();
		});
		$giftCardPin.one('keyup', function () {
			removeValidationError();
		});

		$giftCardNumber.on('keyup', markFieldFilled);
		$giftCardNumber.on('paste', function (e) {
			var $input = $(this);
			var pasteDigitsOnlyValue = e.originalEvent.clipboardData.getData('text').replace(/[^\d]/gi, '');
			$input.val(pasteDigitsOnlyValue);
			markFieldFilled.call($input);
		});
		$giftCardPin.on('keyup paste', markFieldFilled);
		checkFieldsFilled();
	}
	function init(callback) {
		$container = $("#gift-card-payment-type");
		$form = $('#payment form');
		callbackRefreshCart = callback;
		setElements();
		setEvents();
	}

	return {
		init,
		show,
		hide,
		valid: giftCardNumberValid
	};
});
